import { render, staticRenderFns } from "./header-default.vue?vue&type=template&id=237f32dc&scoped=true&"
import script from "./header-default.vue?vue&type=script&lang=js&"
export * from "./header-default.vue?vue&type=script&lang=js&"
import style0 from "./header-default.vue?vue&type=style&index=0&id=237f32dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237f32dc",
  null
  
)

export default component.exports